import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container-smco">
      <div className="footer-grid-smco container mx-auto px-5">
        {/* Column 1: Company Logo & Description */}
        <div>
          <h2 className="text-sm uppercase font-bold">Money Vision </h2>
          <p className="footer-text-smco">
            We provide financial solutions tailored to your needs. Secure and
            fast loan approvals.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h3 className="footer-title-smco">Quick Links</h3>
          <ul>
            <li>
              <button
                onClick={() => navigate("/about-money-vision-advisory")}
                className="footer-link-smco"
              >
                About Us
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/apply-loan-online")}
                className="footer-link-smco"
              >
                Apply Now
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/contact-loan-experts")}
                className="footer-link-smco"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        {/* Column 3: Loan Services List */}
        <div>
          <h3 className="footer-title-smco">Loan Services</h3>
          <ul>
            <li>
              <button
                onClick={() => navigate("/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Personal Loan
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/business-loan-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Business Loan
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/home-loan-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Home Loan
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Mortgage Loan
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/working-capital-loan-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Working Capital Loan
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/loan-against-shares-mumbai-thane-palghar-maharashtra-delhi-india")}
                className="footer-link-smco"
              >
                Loan Against Shares
              </button>
            </li>
          </ul>
        </div>

        {/* Column 4: Contact Information */}
        <div>
          <h3 className="footer-title-smco">Contact Us</h3>
          <p className="footer-text-smco">
            <i className="fas fa-map-marker-alt footer-icon-smco"></i> Office 07, Ajanta Square Mall, Market Lane, Near Borivali Court, Borivali West Mumbai - 400092
          </p>
          <p className="footer-text-smco mt-2">
            <i className="fas fa-phone footer-icon-smco"></i> +91 7506550715          </p>
          <p className="footer-text-smco mt-2">
            <i className="fas fa-envelope footer-icon-smco"></i> surendra.pal@moneyvision.co
          </p>
        </div>
      </div>
      <div className="footer-bottom-copyright">
        <p className="footer-text-smco">&copy; {new Date().getFullYear()} <a href="#" target="_blank"
          rel="noreferrer">copy-rights reserved</a>, Designed by <a href="https://100billiontech.com/" target="_blank"
            rel="noreferrer">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
